import React, {useEffect, useRef, useState} from 'react';
import {IonButtons, IonHeader, IonPage} from '@ionic/react';
import {useTranslation} from 'react-i18next';
import {RouteComponentProps, useHistory} from "react-router-dom";

import {log} from "@services/firebaseAnalytics.service";

import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from '@components/content/content.style';
import {StyledHeaderButton, StyledHeaderButtonImage} from "@components/button/button.style";

import ArrowLeftImage from "@assets/images/arrow-left.svg";
import ReportApplicationPreviewPane from "@app/helpdesk/reportApplication/panes/reportApplicationPreviewPane.component";

interface RouterProps {
    applicationId: string;
}

interface ReportApplicationPreviewPageProps extends RouteComponentProps<RouterProps> {
}

const ReportApplicationPreviewPage: React.FC<ReportApplicationPreviewPageProps> = ({match}: ReportApplicationPreviewPageProps) => {
    const {t} = useTranslation();
    const history = useHistory();

    const {params: {applicationId}} = match;

    const header = useRef<HTMLIonHeaderElement>(null);
    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);

    useEffect(() => {
        log('page_visit', {
            page: 'Helpdesk -> Podgląd wniosku'
        });

        updateHeight();
    }, []);

    const updateHeight = () => {
        if (header.current?.clientHeight === 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const handleBack = () => {
        history.goBack();
    };

    return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <IonButtons slot="start">
                            <StyledHeaderButton onClick={() => handleBack()}>
                                <StyledHeaderButtonImage src={ArrowLeftImage}></StyledHeaderButtonImage>
                            </StyledHeaderButton>
                        </IonButtons>
                        <StyledIonTitle>{t("reportApplicationPage.title_preview")}</StyledIonTitle>
                    </StyledIonToolbar>
                </IonHeader>
                <ReportApplicationPreviewPane topEdge={topEdge} applicationId={parseInt(applicationId)}/>
            </StyledIonContent>
        </IonPage>
    );
};

export default ReportApplicationPreviewPage;